<template>
  <v-container fluid>
    <v-layout>
      <v-container>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >

          <v-card>
            <v-toolbar
              card
              color="#0C116F">
              <v-toolbar-title class="white--text">Create Fulltext Search</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-text-field
                v-model="search.name"
                label="Name"
                :rules="[v => !!v || 'Please specify a name for the search']"
                data-vv-name="name"
                required
                outline
              ></v-text-field>

              <v-textarea
                name="input-7-1"
                v-model="search.search_query"
                :rules="[v => !!v || 'Please specify a query']"
                label="Search Query"
                hint="This query will be translated to an Athena regex used for fulltext matching"
                outline
                rows="20"
              ></v-textarea>

          <v-card>
            <v-toolbar
              card
              color="grey lighten-3">
              <v-toolbar-title>Validation</v-toolbar-title>
            </v-toolbar>

            <v-card-text>

              <v-form
                ref="testinput_form"
              >
                <v-text-field
                  v-model="testInput"
                  label="Test Input Data"
                  hint="Enter some test string to see if the pattern is matching"
                  loading
                >
                  <v-progress-linear
                    slot="progress"
                    :value="progress"
                    :color="testInputColor"
                    height="7"
                  ></v-progress-linear>

                </v-text-field>

              </v-form>

            </v-card-text>

          </v-card>
 
              <v-textarea
                label="Regex from Fulltext Search"
                v-model="Regex_from_Fulltext_search"
                rows="1"
                outline
                auto-grow
                readonly
              ></v-textarea>

              <v-btn @click="validateQuery"
                     color="green darken-1"
                     class="white--text"
                     large>
                Validate with Athena
                <v-icon right dark>verified_user</v-icon>
              </v-btn>

              <v-text-field
                name="input-7-1"
                v-model="search.Author_Query"
                class="mt-2"
                label="Author Query"
                hint="Query to filter results for the given author"
                outline
              ></v-text-field>
              
              <v-select
                v-model="search.language_code"
                :items="languageCodes"
                attach
                outline
                chips
                hint="Based on this language code the ubermetrics language will be set"                
                label="Language Code"
                color="purple"
                multiple
                required
                :rules="[(v) =>  v.length>0 || 'Please provide at least one language code']"
              ></v-select>

              <v-select
                v-model="search.datasource"
                :items="dataSources"
                attach
                outline
                chips
                hint="This is the fulltext data that should be used"                
                label="Datasource"
                color="purple"
              ></v-select>              

              <v-switch
                v-model="search.search_status"
                :label="`ACTIVE SEARCH`"
              ></v-switch>

              <v-switch
                v-model="search.backward_search"
                :label="`BACKWARD SEARCH`"
              ></v-switch>

              <v-btn color="error" @click="submit">Create Fulltext Search</v-btn>
              <v-btn @click="cancel">Cancel</v-btn>

            </v-card-text>

            <v-snackbar
              v-model="snackbar"
              :multi-line="true"
              :timeout="6000"
              :top="true"
              :vertical="true"
            >
              {{ text }}
              <v-btn
                color="pink"
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>

          </v-card>
        </v-form>
      </v-container>
    </v-layout>
    <v-dialog v-model="validate_dialog" max-width="800px">
  <v-card>
    <v-card-title class="headline">Query Validation</v-card-title>
    <v-card-text>
      <div v-if="validatedFragments.length">
        <v-list>
          <template v-for="(msg, index) in validatedFragments">
            <v-list-item :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ msg }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < validatedFragments.length - 1"></v-divider>
          </template>
        </v-list>
      </div>
      <div v-else>No validation messages (yet).</div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="validate_dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'
  import _ from 'underscore';

  export default {
    data () {
      return {
        search: {
          language_code: ['DE'],
          datasource: 'pressrelations-daily',
          search_query: '',
          Author_Query: '',
          name: null,
          search_status: true,
          backward_search: true
        },
        Regex_from_Fulltext_search: null,
        regexDict: {
          fulltextquery: '',
          event_type: '',
          used_table: 'fulltext',
        },
        valid: true,
        snackbar: false,
        validTestInput: false,
        validate_dialog: false,
        validatedFragments: [],
        testInput: '',
        text: null,
        languageCodes: Config.LANGUAGE_CODES.sort(),
        dataSources: Config.DATASOURCES
      }
    },
    mounted () {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
    },
  watch: {
    Regex_from_Fulltext_search(newVal) {
      this.regexDict.fulltextquery = newVal;
    },

    'testInput': function (newValue, oldValue) {
      clearTimeout(this.validatationTimeout);

      this.validatationTimeout = setTimeout(() => {
        let payload = {
          Search_in_Ubermetrics: this.search.search_query,
          test_input: this.testInput,
        };
        this.validTestInput = false;
        this.$emit('TriggerLoading', true);
        let base64Payload = Buffer.from(JSON.stringify(payload)).toString('base64');
        
        axios.post(`${Config.REGEX_API_URL}/helper`,{query: base64Payload,helpertype:'run_regex_fulltext'}).then(response => {
          this.validTestInput = response.data.Match_available;
          this.$emit('TriggerLoading', false);
        }).catch(error => {
          console.log(error);
          this.text = error;
          this.snackbar = true;
          this.$emit('TriggerLoading', false);          
        });

      }, 1000);
    },    
    'search.search_query': _.debounce(
      function (newValue, oldValue) {

        let base64Search = Buffer.from(newValue).toString('base64');
        axios.post(`${Config.REGEX_API_URL}/helper`,{query: base64Search,helpertype:'searchformatfulltext'}).then(response => {
          this.Regex_from_Fulltext_search = response.data.Regex_from_Fulltext_search;
        }).catch(error => {
          console.log(error);
          this.errored = true;
        });
      },
      500,
    ),
    
  }, 
  computed: {
    progress() {
      return (this.validTestInput ? 100 : 100);
    },
    testInputColor() {
      return (this.validTestInput ? 'success' : 'error');
    },
  },           
    methods: {
      'cancel': function () {
        this.$router.go(-1)
      },
      'submit': function () {

        if (this.$refs.form.validate()) {

          this.$emit('TriggerLoading', true)

          console.info(`Submit Search ${this.$route.params.id}: ${JSON.stringify(this.$data.search)}`)
          axios
            .post(`${Config.API_URL}/ubermetrics-searches`, this.$data.search)
            .then(response => {
              console.info(response.data)
              this.text = response.data.message
              this.$emit('TriggerLoading', false)
              this.snackbar = true
            })
            .catch(error => {
              console.log(error)
              this.text = error
              this.errored = true
              this.snackbar = true
            })
        }
      },
     'validateQuery': function () {
        this.$emit('TriggerLoading', true);

        let postData;

        if (
          this.search.language_code.length > 0
        ) {
          postData = this.$data.regexDict.fulltextquery +
            '_separator___value_' +
            this.search.language_code[0].toLowerCase() +
            '_separator___value_' +
            this.$data.regexDict.used_table;

        } else {
          postData = this.$data.regexDict.fulltextquery +
            '_separator___value_de_separator___value_' +
            this.$data.regexDict.used_table;

          // Posting with default (german) language 'de'
        }

        axios.post(`${Config.API_URL}/event_regex/validate`, postData)
          .then(response => {
            console.info('Response from validate:', response);
            this.validatedFragments = response.data.fragments;
            console.log(this.validatedFragments);
            this.validate_dialog = true;
            this.$emit('TriggerLoading', false);
          })
          .catch(error => {
            this.text = `${error.response.data.message || 'Unknown error'} (${error})`;
            this.snackbar = true;
            this.$emit('TriggerLoading', false);
          });
      }
    },
  }
</script>
